module.exports = "<a\n\t[routerLink]=\"['/shared-list/' + sharedList.$key]\"\n\tclass=\"list-link\"\n>\n\t<span class=\"list-name\">{{ sharedList.name }}<span class=\"list-owner\">&nbsp;&mdash;&nbsp;by {{ sharedList.ownerName | async }}</span></span>\n\n\t<span class=\"shared-at\">{{ sharedList.createdAt | date:'M/d/yy' }}</span>\n</a>"


//////////////////
// WEBPACK FOOTER
// /Users/briznad/Documents/WebDev/personal/cartmigo/cartmigo-beta/src/app/components/manage-shared-list/manage-shared-list.html
// module id = ../../../../../src/app/components/manage-shared-list/manage-shared-list.html
// module chunks = 1